import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNotification } from '../contexts/NotificationContext';

export const useTokenExpiration = () => {
  const { user, setUser } = useAuth();
  const { showNotification } = useNotification();
  const hasHandledExpiration = useRef(false);

  useEffect(() => {
    const handleTokenExpired = (event: CustomEvent) => {
      // Prevent multiple notifications for the same event
      if (hasHandledExpiration.current || !user) return;
      
      hasHandledExpiration.current = true;
      
      // Show notification about session expiration
      showNotification(
        event.detail?.message || 'Session expired. Please log in again.',
        'warning',
        8000
      );
      
      // Clear user state and redirect to login
      setUser(null);
    };

    window.addEventListener('tokenExpired', handleTokenExpired as EventListener);

    return () => {
      window.removeEventListener('tokenExpired', handleTokenExpired as EventListener);
    };
  }, [showNotification, user, setUser]);

  // Reset the flag when user logs in again
  useEffect(() => {
    if (user) {
      hasHandledExpiration.current = false;
    }
  }, [user]);
};
